<template>
  <t-default-entry
    v-show="finishCheckAuthen"
    sub-heading="Login"
    heading="初回ログイン"
    :navigation-items="navigationItems"
    :class="componentClassName"
  >
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
    <div v-if="error" class="t-login-invited-user-set-password__alert">
      <a-alert :title="errorMessage" color="error" size="small" />
    </div>
    <form class="t-login-invited-user-set-password__form" @submit.prevent="handleFormSubmit">
      <div class="t-login-invited-user-set-password__group">
        <div class="t-login-invited-user-set-password__instruction">
          <a-heading tag="h4">パスワード変更</a-heading>
          <a-text>新しいパスワードを設定してください</a-text>
        </div>
        <!--
          20210621 メールリンク認証メール送付の際にセッションを削除する要件となったため、
          セッションから契約ID、ユーザーIDが取得できない。
          そのため、契約IDとユーザーIDを入力させ、入力値を利用して、認証コードの正当性確認APIを実行する。
        -->
        <m-form-input class="t-login__input" label="契約ID">
          <a-text-field
            id="company-id"
            v-model="formData.companyID"
            type="text"
            name=""
            placeholder="012345"
            autocomplete="on"
          />
        </m-form-input>
        <m-form-input class="t-login__input" label="ユーザーID">
          <a-text-field
            id="userid"
            v-model="formData.userID"
            type="email"
            name=""
            placeholder="dummy@gmail.com"
            autocomplete="email"
          />
        </m-form-input>
        <m-form-input class="t-login-invited-user-set-password__input" label="初期パスワード">
          <a-text-field
            id="old-password"
            v-model="formData.old_password"
            type="password"
            placeholder="初期パスワード"
          />
        </m-form-input>
        <m-form-input class="t-login-invited-user-set-password__input" label="新しいパスワード">
          <a-text-field id="password" v-model="formData.password" type="password" placeholder="新しいパスワード" />
        </m-form-input>
        <m-form-input class="t-login-invited-user-set-password__input" label="新しいパスワード(確認)">
          <a-text-field
            id="password-conf"
            v-model="formData.password_confirm"
            type="password"
            placeholder="新しいパスワード"
          />
        </m-form-input>
        <div class="t-login-invited-user-set-password__password-condition">
          <a-text :text="passwordCondition" size="small" />
        </div>
      </div>
      <m-button-container class="t-login-invited-user-set-password__buttons">
        <a-button id="next" variant="block" submit="submit" color="primary">次へ</a-button>
        <!-- <a-button color="primary" class="t-invited-user-set-password__button-optional" @click="handleCancelClick">
          戻る
        </a-button> -->
      </m-button-container>
    </form>
    <teleport to="body">
      <o-modal
        id="loginInvitedUserSetPassword_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-login-invited-user-set-password-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
        <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
        </template>
      </o-modal>
    </teleport>
  </t-default-entry>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AAlert from '@/components/atoms/alert';
import AButton from '@/components/atoms/button';
import ATextField from '@/components/atoms/text-field';
import MButtonContainer from '@/components/molecules/button-container';
import MFormInput from '@/components/molecules/form-input';
import TDefaultEntry from '@/components/templates/default-entry';
import AHeading from '@/components/atoms/heading';
import AText from '@/components/atoms/text';
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';
import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import Loading from 'vue-loading-overlay';

export default {
  name: 't-login-invited-user-set-password',
  components: {
    AAlert,
    AButton,
    ATextField,
    MButtonContainer,
    MFormInput,
    TDefaultEntry,
    AHeading,
    AText,
    Loading,
  },
  mixins: [customValidate, customRequest],
  props: {
    // error: {
    //   type: Boolean,
    //   default: false,
    // },
    // errorMessage: {
    //   type: String,
    //   default: '',
    // },
    class: {
      type: String,
      default: '',
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    // handleSubmitForm: {
    //   type: Function,
    //   default: () => {},
    // },
    // handleCancelClick: {
    //   type: Function,
    //   default: () => {},
    // },
  },
  data() {
    return {
      formData: {
        companyID: '',
        userID: '',
        old_password: '',
        password: '',
        password_confirm: '',
      },
      error: false,
      errorMessage: '',
      authFlag: false,
      passwordCondition: messageContent.passwordCondition,

      // modal
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,

      finishCheckAuthen: false,
      isLoading: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-login-invited-user-set-password');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created: function () {
    this.postRequest('/sessioncheck')
      .then(res => {
        console.log(res.codeAuthFlag, this.$route.query.XNcomSignature);
        if (res.codeAuthFlag && this.$route.query.XNcomSignature) {
          // コード認証の場合メールリンク認証は無効になります
          this.$router.push({ path: '/notfound' });
          return;
        }
        if (res.session) {
          if (res.tempPwdFlag) {
            this.postRequest('/login/logout').then(data => {
              if (data.status === 'success') {
                window.location.href = '/login';
              } else {
                this.showErrorModal(messageContent.logoutOtherError);
              }
            });
          } else if (res.firstVisitFlag && res.authInfo === 'supervisor') {
            // ウォークスルーページはマスタ管理者のみアクセス可能
            this.$router.push({ name: 'WTInviteUser' });
          } else {
            this.$router.push({ name: 'Home' });
          }
        } else {
          this.finishCheckAuthen = true;
        }
      })
      .catch(err => {
        this.finishCheckAuthen = true;
        this.setError(messageContent.requireTry('検索'));
      });
  },
  methods: {
    ...mapActions(['updateLoginInfo']),
    handleFormSubmit(event) {
      event.preventDefault();
      const payload = cloneDeep(this.formData);
      if (this.validateForm(payload)) {
        this.handleSubmitForm(payload);
      }
    },
    validateForm(payload) {
      this.resetError();
      // Required check
      if (
        !payload.companyID ||
        !payload.userID ||
        !payload.old_password ||
        !payload.password ||
        !payload.password_confirm
      ) {
        this.setError(messageContent.allFieldIsRequired);
        return false;
      }
      // Pattern check
      // #3130 For Trial
      let patChk = this.companyIDCheck(payload.companyID);
      if (!patChk.status) {
        this.setError(patChk.message);
        return false;
      }
      patChk = this.userIDCheck(payload.userID);
      if (!patChk.status) {
        this.setError(patChk.message);
        return false;
      }
      patChk = this.passwordCheck(payload.old_password, '旧パスワード');
      if (!patChk.status) {
        this.setError(patChk.message);
        return false;
      }
      patChk = this.passwordCheck(payload.password, 'パスワード');
      if (!patChk.status) {
        this.setError(patChk.message);
        return false;
      }
      patChk = this.passwordCheck(payload.password_confirm, '新しいパスワードの確認');
      if (!patChk.status) {
        this.setError(patChk.message);
        return false;
      }
      // Same password check
      if (payload.password !== payload.password_confirm) {
        this.setError(messageContent.passwordNotSame);
        return false;
      }
      return true;
    },
    resetError() {
      this.error = false;
      this.errorMessage = '';
    },
    setError(message) {
      this.error = true;
      this.errorMessage = message;
    },
    handleSubmitForm: async function (payload) {
      this.isLoading = true;
      // メールリンク認証が成功した場合のみパスワード変更を行う
      const formData = {
        password: payload.old_password,
        newPassword: payload.password,
        companyID: payload.companyID,
        userID: payload.userID,
        authCode: this.$route.query.XNcomSignature,
      };
      await this.postRequest('/login/changePassword', formData)
        .then(res => {
          if (res.session) {
            // #2954
            this.setCookie('notifyMessageDisplayFlag', 'ON');
            // Logged user updating is unnessary due to nothing be changed
            // this.updateLoginInfo(res.data);
            if (res.data.firstVisitFlag && res.data.authInfo !== 'operator' && res.data.authInfo !== 'オペレーター') {
              //TODO: remove english key later
              this.$router.push({ name: 'WTInviteUser' });
            } else {
              this.$router.push({ name: this.$route.params.isSalesforce ? 'SfHome' : 'Home' });
            }
          } else {
            if (res.status === 'resetPassword') {
              //仮パスワードの場合
              this.$router.push({ path: '/resettemppassword' });
            } else if (res.status === 'duringMailAuth') {
              //メールリンク認証中の場合、ログインできません。
              this.$router.push({ path: '/no-mail-auth' });
            } else if (res.status === 'createdMailLink') {
              //有効期限切りになると、メールリンク認証を作成、認証リンクをメールで送信
              this.isLoading = false;
              const modalMessage = res.tempPwdFlag
                ? messageContent.loginEmailAuthSend
                : messageContent.loginEmailAuthResend;
              this.showInfoModal(modalMessage);
            } else if (res.status === 'mailLinkInvalid' || res.status === 'mailLinkCountFail') {
              //認証コードが間違い
              this.$router.push({ path: '/error' });
            } else if (res.status === 'loginFailed') {
              this.isLoading = false;
              this.errorMessage = res.msg;
              this.setError(this.errorMessage);
            } else {
              this.isLoading = false;
              this.errorMessage = messageContent.loginOtherError;
              this.setError(this.errorMessage);
            }
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.errorMessage = messageContent.loginOtherError;
          this.error = true;
        });
      // handleCheckAuthCodeで画面遷移済みのため、if文の条件がtrueとならない場合は処理無し
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    // #2954
    setCookie(key, value, expires = null) {
      if (!expires) {
        const d = new Date();
        // Cookie expires after 3 days
        d.setTime(d.getTime() + 3 * 24 * 60 * 60 * 1000);
        expires = 'expires=' + d.toUTCString();
      }
      document.cookie = `${key}=${value};expires=${expires}`;
    },
  },
};
</script>
